export default __webpack_public_path__ + "assets/images/7c5c14544a6f6a6136d2c039fe938711.svg";